"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useDeepCompareMemoize = _interopRequireDefault(require("../useDeepCompareMemoize"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useDeepCompareCallback = function useDeepCompareCallback(callback, dependencies) {
  return (
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, _react.useCallback)(callback, dependencies.map(_useDeepCompareMemoize.default))
  );
};
var _default = useDeepCompareCallback;
exports.default = _default;